export enum MedicationAdministrationMethodEnum {
  ORAL = "oral",
  SUBLINGUAL = "sublingual",
  RECTAL = "rectal",
  TOPICAL = "topical",
  TRANSDERMAL = "transdermal",
  SUBCUTANEOUS = "subcutaneous",
  INTRAMUSCULAR = "intramuscular",
  INTRAVENOUS = "intravenous",
  OTHER = "other",
}

export const MedicationAdministrationDropdownOptions = [
  { value: MedicationAdministrationMethodEnum.ORAL, label: "Oral" },
  { value: MedicationAdministrationMethodEnum.SUBLINGUAL, label: "Sublingual" },
  { value: MedicationAdministrationMethodEnum.RECTAL, label: "Rectal" },
  { value: MedicationAdministrationMethodEnum.TOPICAL, label: "Topical" },
  {
    value: MedicationAdministrationMethodEnum.TRANSDERMAL,
    label: "Transdermal",
  },
  {
    value: MedicationAdministrationMethodEnum.SUBCUTANEOUS,
    label: "Subcutaneous",
  },
  {
    value: MedicationAdministrationMethodEnum.INTRAMUSCULAR,
    label: "Intramuscular",
  },
  {
    value: MedicationAdministrationMethodEnum.INTRAVENOUS,
    label: "Intravenous",
  },
  { value: MedicationAdministrationMethodEnum.OTHER, label: "Other" },
];
